import {
  HStack,
  InputGroup,
  VStack,
  InputRightElement,
  Input as InputComponent,
  Box,
  useColorModeValue,
  Text,
  Switch,
  Flex,
  Button
} from '@chakra-ui/react';
import { Checkbox, Input, Select } from 'antd';
import {
  DateBox,
  InputBox,
  SelectBox,
  SwitchBox,
  TextBox,
  TimeBox,
} from './SharedModules';
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from 'react-places-autocomplete';
import { DownOutlined, UserOutlined } from '@ant-design/icons';
import { Button as ABT, Dropdown, Space } from 'antd';
import { theme } from '../../../../styles/theme/base';
import { useState, useEffect } from 'react';
import LocationAutocomplete from '../../../../utils/autocomplete';
import secrets from '../../../../secrets';
import { message } from 'antd';
import { useMediaQuery } from '../../../../utils/useMediaQuery';
import languageIcon from '../../../../static/assets/images/language.svg';
import { useLocation } from 'react-router-dom';

import './styles.css';

/**
 * This is a React component that renders a form for creating basic events, including fields for event
 * name, type, start and end dates and times, location, and description.
 * @param props - The `props` parameter is an object that contains various properties passed down from
 * the parent component to the `BasicEvents` component. These properties include `handleBlur`,
 * `handleChange`, `values`, and `setFieldValue`, which are likely functions or state variables used to
 * manage form input and state. The
 * @returns The BasicEvents component is being returned, which renders a form with input fields for
 * event name, event type, start and end dates and times, location, and description. The event type
 * field is a dropdown menu with options for Night Club, Music, Techno, and Conference. The location
 * field uses the LocationAutocomplete component to allow users to search for and select a location
 * using the Google Maps API
 */
const TagsResell = (props) => {
  const isMobile = useMediaQuery('(max-width: 768px)');
  const { handleBlur, handleChange, values, setFieldValue } = props;
  const textValue = useColorModeValue(
    theme.colors.black[100],
    theme.colors.white[100]
  );
  const [selectedEvent, setSelectedEvent] = useState(values.eventType || []);
  const location = useLocation();
  const shouldShowContent = location.pathname.includes('/edit');
  const [customTag, setCustomTag] = useState('');

  const handleCheckboxChange = (checkedValues) => {
    if (checkedValues.length <= 5) {
      setFieldValue('eventType', checkedValues);
      setSelectedEvent(checkedValues);
    } else {
      // Display a message or take appropriate action when the limit is reached
      message.warning('You can select up to 5 values.');
    }
  };

  const handleCustomTagAdd = () => {
    if (!customTag.trim()) return;

    if (selectedEvent.length >= 5) {
      message.warning('You can select up to 5 values.');
      return;
    }

    if (selectedEvent.includes(customTag)) {
      message.warning('This tag already exists.');
      return;
    }

    setFieldValue('eventType', [...selectedEvent, customTag]);
    setSelectedEvent([...selectedEvent, customTag]);
    setCustomTag('');
  };

  const tagsOptions = [
    {
      label: 'Avant Gardner',
      value: 'Avant Gardner',
    },
    {
      label: 'B. Mirage',
      value: 'B. Mirage',
    },
    {
      label: 'B. Storehouse',
      value: 'B. Storehouse',
    },
    {
      label: 'Caveau',
      value: 'Caveau',
    },
    {
      label: 'City Market',
      value: 'City Market',
    },
    {
      label: 'Club Space',
      value: 'Club Space',
    },
    {
      label: 'Gin Ling Way',
      value: 'Gin Ling Way',
    },
    {
      label: 'Jungle Island',
      value: 'Jungle Island',
    },
    {
      label: 'Knockdown C',
      value: 'Knockdown C',
    },
    {
      label: 'MGM Music',
      value: 'MGM Music',
    },
    {
      label: 'One California',
      value: 'One California',
    },
    {
      label: 'Royale',
      value: 'Royale',
    },
    {
      label: 'Sound N',
      value: 'Sound N',
    },
    {
      label: 'S Illustrated S',
      value: 'S Illustrated S',
    },
  ];

  useEffect(() => {
    setSelectedEvent(values.eventType || []);
  }, [values.eventType]);

  return (
    <VStack spacing={'2.19rem'} w="100%">
      <Box w={'100%'}>
        <Text
          fontSize={'1.3125rem'}
          mb="0.94rem"
          textTransform={'capitalize'}
          color={textValue}
          className="gordita600"
          fontWeight={500}
        >
          {'Tags'}
        </Text>
        <Text
          fontSize={'1rem'}
          color={'rgba(255, 255, 255, 0.60)'}
          className="gordita400"
          mb={'1.56rem'}
        >
          Click and select 1 to 5 tags maximum.
        </Text>
        <InputGroup mb={4}>
          <InputComponent
            placeholder="Add custom tag"
            value={customTag}
            onChange={(e) => setCustomTag(e.target.value)}
            pr="4.5rem"
          />
          <InputRightElement width="4.5rem">
            <Button size="sm" onClick={handleCustomTagAdd}>
              Add
            </Button>
          </InputRightElement>
        </InputGroup>
        <Checkbox.Group
          options={[
            ...tagsOptions,
            ...selectedEvent
              .filter((tag) => !tagsOptions.find((t) => t.value === tag))
              .map((tag) => ({ label: tag, value: tag })),
          ]}
          value={selectedEvent}
          onChange={handleCheckboxChange}
          className="tags-container"
          style={{ width: '100%' }}
        />
      </Box>
    </VStack>
  );
};

export default TagsResell;
